<nav
    class="navbar navbar-expand-lg fixed-top navbar-transparent animate__fadeInDown"
    color-on-scroll="10"
    id="navbar-top">
    <div class="container px-0">
        <div class="navbar-translate">
            <a
                class="navbar-brand"
                placement="bottom"
                [routerLink]="['/']"
                target="_self"
                title="前往首頁">
                <div class="logo d-flex justify-content-center">
                    <img
                        [src]="
                            !isEnglish()
                                ? '../../../assets/images/Kunyou-Logo.png'
                                : '../../../assets/images/Kunyou-Logo-english.png'
                        "
                        alt="坤侑科技"
                        width="80%" />
                    <h1 class="m-0">
                        KunYou 坤侑科技 | 致力於資訊整合，提供客製化解決方案的團隊
                    </h1>
                </div>
            </a>
            <button
                aria-controls="navigation-index"
                aria-label="Toggle navigation"
                class="navbar-toggler navbar-toggler"
                [attr.aria-expanded]="!isCollapsed"
                (click)="ToggleBGFilter()"
                id="navigation"
                type="button">
                <ng-container *ngIf="isCollapsed">
                    <span class="navbar-toggler">&equiv;</span>
                </ng-container>

                <ng-container *ngIf="!isCollapsed">
                    <span class="navbar-toggler">&#x00d7;</span>
                </ng-container>
            </button>
        </div>
        <div
            class="navbar-collapse justify-content-start"
            [collapse]="isCollapsed"
            id="navigation">
            <ul class="navbar-nav" [class.dropdown-open]="isAnyDropdownOpen()">
                <!-- ! web 2.0 的 navItem 寫在這邊 -->
                <li *ngIf="!isEnglish()" class="nav-item">
                    <a
                        class="nav-link"
                        [routerLink]="['/']"
                        placement="bottom"
                        target="_self"
                        [title]="'navigation.brand.goHome' | translate">
                        <p>{{ 'navigation.home' | translate }}</p>
                    </a>
                </li>
                <li
                    class="nav-item dropdown"
                    [ngClass]="{
                        show: dropdownStates['products']
                    }"
                    (mouseenter)="setDropdownState('products', true)"
                    (mouseleave)="setDropdownState('products', false)">
                    <a
                        class="nav-link dropdown-toggle"
                        [routerLink]="['/products']"
                        placement="bottom"
                        target="_self"
                        [title]="'navigation.brand.goProducts' | translate">
                        <p>{{ 'navigation.products' | translate }}</p>
                    </a>
                    <div
                        class="dropdown-menu"
                        [ngClass]="{ show: dropdownStates['products'] }"
                        aria-labelledby="productDropdown">
                        <a
                            class="dropdown-item"
                            [routerLink]="['/products']"
                            [queryParams]="{ keyword: 'bigdata' }"
                            (click)="closeMenu()">
                            {{ 'navigation.items.bigData' | translate }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/products']"
                            [queryParams]="{ keyword: 'iot' }"
                            (click)="closeMenu()">
                            {{ 'navigation.items.internetofThings' | translate }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/products']"
                            [queryParams]="{ keyword: 'ai' }"
                            (click)="closeMenu()">
                            {{
                                'navigation.items.artifiialIntelligence' | translate
                            }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/products']"
                            [queryParams]="{ keyword: 'info-security' }"
                            (click)="closeMenu()">
                            {{ 'navigation.items.informationSecurity' | translate }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/products']"
                            [queryParams]="{ keyword: 'data-consolidation' }"
                            (click)="closeMenu()">
                            {{ 'navigation.items.dataIntegration' | translate }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/products']"
                            [queryParams]="{ keyword: 'technical-support' }"
                            (click)="closeMenu()">
                            {{ 'navigation.items.technicalSupport' | translate }}
                        </a>
                    </div>
                </li>
                <li
                    class="nav-item dropdown"
                    [ngClass]="{
                        show: dropdownStates['solutions']
                    }"
                    (mouseenter)="setDropdownState('solutions', true)"
                    (mouseleave)="setDropdownState('solutions', false)">
                    <a
                        class="nav-link"
                        [routerLink]="['/solutions']"
                        placement="bottom"
                        target="_self"
                        [title]="'navigation.brand.goSolutions' | translate">
                        <p>{{ 'navigation.solutions' | translate }}</p>
                    </a>
                    <div
                        class="dropdown-menu"
                        [ngClass]="{ show: dropdownStates['solutions'] }"
                        aria-labelledby="solutionsDropdown">
                        <a
                            class="dropdown-item"
                            [routerLink]="['/solutions/explore/investForensics']"
                            (click)="closeMenu()">
                            {{ 'navigation.items.techInvestigationDigitalForensics' | translate }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/solutions/explore/securityMonitor']"
                            (click)="closeMenu()">
                            {{ 'navigation.items.smartSecurityFieldMonitoring' | translate }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/solutions/explore/intelGovern']"
                            (click)="closeMenu()">
                            {{
                                'navigation.items.intelIntegrationSmartGovernance'
                                    | translate
                            }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/solutions/explore/logisticsTransport']"
                            (click)="closeMenu()">
                            {{
                                'navigation.items.smartLogisticsTransportMgmt'
                                    | translate
                            }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/solutions/explore/coreOpsHR']"
                            (click)="closeMenu()">
                            {{
                                'navigation.items.coreOpsHRManagement'
                                    | translate
                            }}
                        </a>
                    </div>
                </li>
                <li
                    class="nav-item dropdown"
                    [ngClass]="{
                        show: dropdownStates['aboutKunYu']
                    }"
                    (mouseenter)="setDropdownState('aboutKunYu', true)"
                    (mouseleave)="setDropdownState('aboutKunYu', false)">
                    <a
                        class="nav-link"
                        [routerLink]="['/aboutKunYu']"
                        placement="bottom"
                        target="_self"
                        [title]="'navigation.brand.goAbout' | translate">
                        <p>{{ 'navigation.about' | translate }}</p>
                    </a>
                    <div
                        class="dropdown-menu"
                        [ngClass]="{ show: dropdownStates['aboutKunYu'] }"
                        aria-labelledby="aboutKunYuDropdown">
                        <a
                            class="dropdown-item"
                            [routerLink]="['/aboutKunYu']"
                            (click)="closeMenu()">
                            {{ 'navigation.items.companyProfile' | translate }}
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/corporatePhilosophy']"
                            (click)="closeMenu()">
                            {{ 'navigation.items.corporatePhilosophy' | translate }}
                        </a>
                    </div>
                </li>
                <li
                    *ngIf="!isEnglish()"
                    class="nav-item dropdown"
                    [ngClass]="{
                        show: dropdownStates['newsCenter']
                    }"
                    (mouseenter)="setDropdownState('newsCenter', true)"
                    (mouseleave)="setDropdownState('newsCenter', false)">
                    <a
                        class="nav-link"
                        [routerLink]="['/newsCenter']"
                        placement="bottom"
                        target="_self"
                        title="前往新聞中心">
                        <p>{{ 'navigation.news' | translate }}</p>
                    </a>
                    <div
                        class="dropdown-menu"
                        [ngClass]="{ show: dropdownStates['newsCenter'] }"
                        aria-labelledby="newsCenterDropdown">
                        <a
                            class="dropdown-item"
                            [routerLink]="['/newsCenter']"
                            [queryParams]="{ newsType: 2 }"
                            (click)="closeMenu()">
                            新聞與活動
                        </a>
                        <a
                            class="dropdown-item"
                            [routerLink]="['/newsCenter']"
                            [queryParams]="{ newsType: 3 }"
                            (click)="closeMenu()">
                            電子報
                        </a>
                    </div>
                </li>
                <li
                    *ngIf="!isEnglish()"
                    class="nav-item dropdown"
                    [ngClass]="{
                        show: dropdownStates['humanRecruit']
                    }"
                    (mouseenter)="setDropdownState('humanRecruit', true)"
                    (mouseleave)="setDropdownState('humanRecruit', false)">
                    <a
                        class="nav-link"
                        [routerLink]="['/humanRecruit']"
                        placement="bottom"
                        target="_self"
                        title="前往人才招募">
                        <p>{{ 'navigation.recruit' | translate }}</p>
                    </a>
                    <div
                        class="dropdown-menu"
                        [ngClass]="{
                            show: dropdownStates['humanRecruit']
                        }"
                        aria-labelledby="humanRecruitDropdown">
                        <a
                            class="dropdown-item"
                            [routerLink]="['/humanRecruit']"
                            (click)="closeMenu()">
                            加入坤侑
                        </a>
                    </div>
                </li>
                <li
                    class="nav-item dropdown"
                    [ngClass]="{
                        show: dropdownStates['psirt']
                    }"
                    (mouseenter)="setDropdownState('psirt', true)"
                    (mouseleave)="setDropdownState('psirt', false)">
                    <a
                        class="nav-link"
                        [routerLink]="['/psirt']"
                        placement="bottom"
                        target="_self"
                        title="前往安全回報">
                        <p>{{ 'navigation.psirt' | translate }}</p>
                    </a>
                    <div
                        class="dropdown-menu"
                        [ngClass]="{ show: dropdownStates['psirt'] }"
                        aria-labelledby="psirtDropdown">
                        <a
                            class="dropdown-item"
                            [routerLink]="['/psirt']"
                            (click)="closeMenu()">
                            {{ 'navigation.items.psirt' | translate }}
                        </a>
                    </div>
                </li>
                <li
                    class="nav-item dropdown d-mobile"
                    *ngIf="getScreenWidth <= 1023"
                    [ngClass]="{ show: dropdownStates['language'] }"
                    (mouseenter)="setDropdownState('language', true)"
                    (mouseleave)="setDropdownState('language', false)"
                    (click)="
                        setDropdownState('language', !dropdownStates['language'])
                    ">
                    <a class="nav-link dropdown-toggle">
                        <p>{{ 'navigation.language' | translate }}</p>
                    </a>
                    <div
                        class="dropdown-menu"
                        [ngClass]="{ show: dropdownStates['language'] }">
                        <a
                            *ngFor="let language of languages"
                            class="dropdown-item"
                            (click)="onLanguageChange(language.code)">
                            {{ language.name }}
                        </a>
                    </div>
                </li>
                <li class="nav-item d-mobile" *ngIf="getScreenWidth <= 1023">
                    <button class="contact-us-btn" [routerLink]="['/contactUs']">
                        {{ 'navigation.contact' | translate }}
                    </button>
                </li>
            </ul>
        </div>
        <!-- 語系下拉選單 -->
        <div *ngIf="getScreenWidth > 1023" class="d-flex align-items-center">
            <div
                class="nav-item dropdown navber-language-selector"
                [ngClass]="{ show: dropdownStates['language'] }"
                (mouseenter)="setDropdownState('language', true)"
                (mouseleave)="setDropdownState('language', false)">
                <a class="nav-link">
                    <p>{{ getCurrentLanguageName() }}</p>
                </a>
                <div
                    class="dropdown-menu"
                    [ngClass]="{ show: dropdownStates['language'] }">
                    <a
                        *ngFor="let language of languages"
                        class="dropdown-item"
                        (click)="onLanguageChange(language.code)">
                        {{ language.name }}
                    </a>
                </div>
            </div>
            <button class="contact-us-btn" [routerLink]="['/contactUs']">
                {{ 'navigation.contact' | translate }}
            </button>
        </div>
    </div>
</nav>

<app-cookies-dialog></app-cookies-dialog>
